import cn from 'classnames';
import styles from './PageBackdrop.module.scss';
import { useSelector } from 'react-redux';
import { selectSearchActive } from '@/store';
import { useAdaptiveWidth } from '@/hooks/useAdaptiveWidth';

type PageBackdropProps = {
  className?: string;
};

export function PageBackdrop({ className }: PageBackdropProps) {
  const searchActive = useSelector(selectSearchActive);
  const { isTablet } = useAdaptiveWidth();

  const wrapperClassName = cn(
    styles.wrapper,
    {
      [styles.active]: searchActive && isTablet,
    },
    className,
  );

  return <div className={wrapperClassName} />;
}
